export enum FeatureTreatment {
    ON = 'on',
    OFF = 'off',
    VARIANT_A = 'variantA',
    VARIANT_B = 'variantB',
}

/** Individual feature that can be enabled or disabled. */
export type EnabledFeature = {
    /** Whether the feature is enabled. */
    isEnabled: boolean;
    /** Name of the feature. */
    label: string;
    /** Feature flag treatment, used to detect feature variant */
    treatment: FeatureTreatment;
};
